import provider from "./provider";

export default provider;
